<template>
  <div>
    <section class="top-fixing">
      <section class="common-sub-top container">
        <section class="top-info-wrap">
          <!-- 뒤로가가-->
          <div class="prev-wrap">
            <a @click="clickBack" class="close"></a>
          </div>
          <!-- //뒤로가가-->
          <!-- <span class="title">hospcd={{ this.$store.state.storeHospNo }}문진표 선택 {{ receptNo }}-{{ guid }} ip={{ this.$store.state.checkupIp }}</span> -->
          <span class="title">문진표 선택</span>
        </section>
      </section>
    </section>

    <!-- 간격 조정용 -->
    <div class="space"></div>
    <!-- //간격 조정용 -->
    <section class="question-wrap">
      <!-- 좌-->
      <div class="left">
        <!-- v-bind:class="[activeTab === '50' ? 'active' : '']"> -->
        <ul>
          <li v-if="this.$store.state.settingInfo.chkNat === 'Y'">
            <!-- :class="{ disable: guid == null || guid == '' }" -->
            <!-- <li v-show="guid != null" @click="clickChoiceCheckup('0')"> -->
            <figure><img :src="require(`@/assets/images/${icon1}`)" alt="" /></figure>
            <span>국가검진</span>
          </li>
          <li v-if="this.$store.state.settingInfo.chkChild === 'Y'">
            <figure><img :src="require(`@/assets/images/${icon2}`)" alt="" /></figure>
            <span>영유아검진</span>
          </li>

          <li v-if="this.$store.state.settingInfo.chkPsy === 'Y' && licenseType === '2'">
            <figure><img :src="require(`@/assets/images/${icon3}`)" alt="" /></figure>
            <span>정신건강문진</span>
          </li>

          <li v-if="this.$store.state.settingInfo.chkHosp === 'Y'">
            <figure><img :src="require(`@/assets/images/${icon4}`)" alt="" /></figure>
            <span>병원문진</span>
          </li>
        </ul>
      </div>
      <!-- // 좌 -->
      <!-- 우 -->

      <template v-if="this.selectIconNm === '국가검진'">
        <div class="right">
          <div class="bundle">
            <!-- pIdx랑 올해년도랑 같은 경우는 활성화 그외는 비활성화-->
            <template v-if="checkUpViewFlag === 'Y'">
              <template v-if="pIdx == null || pIdx == todayYear">
                <button @click="clickMoveCheckUp()">{{ this.todayYear }}</button>
              </template>
              <template v-else>
                <button @click="clickMoveCheckUp()">{{ pIdx }}</button>
                <button disabled>{{ this.todayYear }}</button>
              </template>
            </template>
            <template v-else>
              <div class="ckeckup-view-none">
                <img :src="require(`@/assets/img/ic_nodocument.png`)" alt="" />
                <span>국가검진 대상자가 아닙니다.</span>
              </div>
            </template>
          </div>
        </div>
      </template>
      <template v-else-if="this.selectIconNm === '정신건강문진'">
        <div class="right">
          <!-- <div class="bundle">
						<button @click="clickMovePsych('CDR')">CDR</button>
						<button @click="clickMovePsych('MMSE')">MMSE</button>
						<button @click="clickMovePsych('HAS')">HAS</button>
						<button @click="clickMovePsych('HAMD')">HAMD</button>
						<button @click="clickMovePsych('GDS')">GDS</button>
					</div>
					<div class="bundle">
						<button @click="clickMovePsych('PDSS')">PDSS</button>
						<button @click="clickMovePsych('PANSS')">PANSS</button>
						<button @click="clickMovePsych('BPRS')">BPRS</button>
						<button @click="clickMovePsych('ASRS')">ASRS</button>
					</div>
					아래는 추가된것 - 명칭정의 필요 -->
          <div class="bundle">
            <template v-if="optionMind.length > 0">
              <button v-for="(item, index) in optionMind" :key="index" @click="clickMovePsychAdd(`${item.pidx}`)">
                <span v-if="item.writeYn === 'Y'" class="write-y">작성완료</span>
                {{ item.paperNm }}
              </button></template
            >
            <template v-else>
              <div class="ckeckup-view-none">
                <img :src="require(`@/assets/img/ic_nodocument.png`)" alt="" />
                <span>정신건강 문진표가 없습니다.</span>
              </div>
            </template>
          </div>
        </div>
      </template>
      <template v-else-if="this.selectIconNm === '병원문진'">
        <div class="right">
          <div class="bundle">
            <template v-if="optionHosp.length > 0">
              <button v-for="(item, index) in optionHosp" :key="index" @click="clickMoveHosp(`${item.intCd}`, `${item.intNm}`, `${item.writeYn}`)">
                <span v-if="item.writeYn === 'Y'" class="write-y">작성완료</span>
                <!-- <template v-else> (미작성)</template> -->

                [{{ item.category }}]
                <template v-if="item.intNm.length > 15"> {{ item.intNm.substr(0, 15) }}... </template>
                <template v-else>{{ item.intNm }}</template>
              </button>
            </template>
            <template v-else>
              <div class="ckeckup-view-none">
                <img :src="require(`@/assets/img/ic_nodocument.png`)" alt="" />
                <span>병원 문진표가 없습니다.</span>
              </div>
            </template>
          </div>
        </div>
      </template>

      <!-- // 우 -->
    </section>

    <!-- 뒤로가기 클릭시 팝업 -->
    <section class="dim-popup-wrap" id="checkupStateModal">
      <section class="dim-popup-mark" @click="checkupModalCancel"></section>
      <section class="dim-popup-content">
        <div class="button close" @click="checkupModalCancel">취소</div>
        <div class="button ok" @click="checkupModalOK">확인</div>
        <div class="text">
          <header>문진 종료</header>
          <div class="body">
            <p>문진을 종료하시려면<br />로그인 아이디를 입력해주세요</p>
            <input type="password" placeholder="로그인 아이디 입력" v-model="loginId" @keyup.enter="checkupModalOK" autocomplete="off" readonly onfocus="this.removeAttribute('readonly');" />
            <p v-show="modalGuide" class="guide">로그인 아이디를 다시 확인해주세요</p>
          </div>
        </div>
      </section>
    </section>
    <!-- // 뒤로가기 클릭시 팝업 -->

    <!-- 비밀번호 팝업 -->
    <PinPassword ref="pinPasswordRef" :propData="propData" @childFunc="parentFunc" />
    <!-- //비밀번호 팝업 -->
  </div>
</template>

<script>
import { popOpenAndScrollNone, popCloseAndScrollAuto } from '@/utils/UtilPopup';
import PinPassword from '@/components/popup/PinPassword';
import $ from 'jquery';
import axios from 'axios';

export default {
  data() {
    return {
      test: 0,
      receptNo: this.$route.params.receptNo,
      guid: this.$route.params.guid,
      ptntInfo: this.$route.params.ptntInfo,
      selectedInfo: this.$route.params.selectedInfo,
      selectIconNm: '',
      pIdx: this.$route.params.pIdx,
      icon1: 'ic-checkup-nor.png',
      icon2: 'ic-infants-nor.png',
      icon3: 'ic-psych-nor.png',
      icon4: 'ic-hosp-nor.png',
      todayYear: '',
      checkUpViewFlag: 'Y',
      optionHosp: [],
      optionMind: [],
      activeTab: this.$route.params.activeTab,
      returnChoiceNm: '',
      loginId: '',
      modalGuide: false,
      propData: {}
    };
  },
  computed: {
    licenseType() {
      return this.$store.state.settingInfo.licenseType;
    }
  },
  watch: {
    loginId(oldVal, newVal) {
      this.modalGuide = false;
    }
  },
  components: {
    PinPassword
  },
  mounted() {
    if (!(this.$route.params.returnChoiceNm == '' || this.$route.params.returnChoiceNm == null)) {
      this.returnChoiceNm = this.$route.params.returnChoiceNm;
    }

    if (this.returnChoiceNm === '병원문진') {
      let url = `/interviewtable/${this.receptNo}`;
      let result = null;
      if (this.$osType === 'web' || this.$osType === 'ios') {
        this.$axios
          .get(url)
          .then((response) => {
            this.optionHosp = response.data.data;
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        result = this.$util.getApi(`${this.$store.state.apiDomain}${url}`);
        this.optionHosp = result.data;
      }
    }
    var d = new Date();
    this.todayYear = d.getFullYear();

    let vm = this;

    //아이콘 클릭 이벤트
    $('.question-wrap .left ul li').click(function () {
      var index = $(this).index();
      var temp = index + 1;
      let choiceNm = $('.question-wrap .left ul li:nth-child(' + temp + ') span').text();

      //아이콘 초기화 (미선택)
      vm.icon1 = 'ic-checkup-nor.png';
      vm.icon2 = 'ic-infants-nor.png';
      vm.icon3 = 'ic-psych-nor.png';
      vm.icon4 = 'ic-hosp-nor.png';

      // shchoi 2021.09.23 주석 담 - 국가검진 비활성화 시키지 않고, 클릭하면 오른쪽에서  '대상자 아니라고'문구가 나오도록 변경 하기로 해서.
      // //국가검진에 guid 키가 없을 경우에는 비활성화
      // if (choiceNm === '국가검진') {
      //     if (vm.guid == null || vm.guid == '') {
      //         // $('.question-wrap .left ul li').removeClass('active');
      //         vm.selectIconNm = '국가검진';
      //         vm.checkUpViewFlag = 'N';
      //         return;
      //     }
      // }

      //선택 문진 테두리 및 아이콘 색상 칠하기
      $('.question-wrap .left ul li').removeClass('active');
      $(this).addClass('active');

      if (choiceNm === '국가검진') {
        vm.icon1 = 'ic-checkup-sel.png';
        vm.selectIconNm = '국가검진';
      } else if (choiceNm === '영유아검진') {
        vm.icon2 = 'ic-infant-sel.png';
        vm.selectIconNm = '영유아검진';
      } else if (choiceNm === '정신건강문진') {
        vm.icon3 = 'ic-phych-sel.png';
        vm.selectIconNm = '정신건강문진';
      } else if (choiceNm === '병원문진') {
        vm.icon4 = 'ic-hosp-sel.png';
        vm.selectIconNm = '병원문진';
      }
      try {
        //병원문진일 경우
        if (vm.selectIconNm === '병원문진') {
          //예약정보 - 상태값 콤보박스
          let url = `/interviewtable/${vm.receptNo}`;
          let result = null;
          vm.$osType;
          if (vm.$osType === 'web' || vm.$osType === 'ios') {
            vm.$axios
              .get(url)
              .then((response) => {
                vm.optionHosp = response.data.data;
              })
              .catch((e) => {
                console.log(e);
              });
          } else {
            let url = `/interviewtable/${vm.receptNo}`;
            result = vm.$util.getApi(`${vm.$store.state.apiDomain}${url}`);
            vm.optionHosp = result.data;
          }
        } else if (vm.selectIconNm === '정신건강문진') {
          clearInterval(vm.$store.state.timerId2);
          if (vm.selectedInfo.mindGuid != '') {
            //정신건강 문진 추가 문진표. (의사가 환자들한테 직접 작성하고 오라는 용도의 문진표)
            let url = `${vm.$store.state.checkupIp}/api/psych/np2/${vm.$store.state.storeHospNo}/req/TB/paperInfos/${vm.selectedInfo.mindGuid}`;
            //	let url = `${this.$store.state.checkupIp}/api/psych/np2/{{요양기관}}/req/TB/paperInfos/{{guid}}`;
            try {
              axios
                .get(url)
                .then((response) => {
                  vm.optionMind = response.data.data;
                })
                .catch((e) => {
                  console.log(e);
                });
              clearInterval(vm.$store.state.timerId2);
              vm.$store.state.timerId2 = setInterval(
                () =>
                  axios
                    .get(url)
                    .then((response) => {
                      vm.optionMind = response.data.data;
                    })
                    .catch((e) => {
                      console.log(e);
                    }),
                3000
              );
            } catch (e) {
              //alert(`문진표 리스트 에러 =${e}`);
            }
          }
        }
      } catch (e) {
        //alert(`error =${e}`);
      }
    });

    //국가검진이 맨위에 있고 guid가 없을 경우에는 선택 비활성화
    if ($('.question-wrap .left ul li:nth-child(1) span').text() === '국가검진') {
      //guid가 없을 경우
      if (this.guid == null || this.guid == '') {
        vm.checkUpViewFlag = 'N'; // 국가검진 guid 없을 경우 다음과 같이 처리

        let choiceNm = '';
        if (this.returnChoiceNm === '' || this.returnChoiceNm === null) {
          choiceNm = $('.question-wrap .left ul li:nth-child(2) span').text();
        } else {
          choiceNm = this.returnChoiceNm;
        }

        $('.question-wrap .left ul li:contains(' + choiceNm + ')').addClass('active');
        if (choiceNm === '국가검진') {
          vm.icon1 = 'ic-checkup-sel.png';
          vm.selectIconNm = '국가검진';
        } else if (choiceNm === '영유아검진') {
          vm.icon2 = 'ic-infant-sel.png';
          vm.selectIconNm = '영유아검진';
        } else if (choiceNm === '정신건강문진') {
          vm.icon3 = 'ic-phych-sel.png';
          vm.selectIconNm = '정신건강문진';
          if (vm.selectedInfo.mindGuid != '') {
            //정신건강 문진 추가 문진표. (의사가 환자들한테 직접 작성하고 오라는 용도의 문진표)
            let url = `${this.$store.state.checkupIp}/api/psych/np2/${vm.$store.state.storeHospNo}/req/TB/paperInfos/${vm.selectedInfo.mindGuid}`;
            //	let url = `${this.$store.state.checkupIp}/api/psych/np2/{{요양기관}}/req/TB/paperInfos/{{guid}}`;
            try {
              axios
                .get(url)
                .then((response) => {
                  vm.optionMind = response.data.data;
                })
                .catch((e) => {
                  console.log(e);
                });
              clearInterval(vm.$store.state.timerId2);
              vm.$store.state.timerId2 = setInterval(
                () =>
                  //this.search(`${this.activeTab}`)
                  axios
                    .get(url)
                    .then((response) => {
                      vm.optionMind = response.data.data;
                    })
                    .catch((e) => {
                      console.log(e);
                    }),
                3000
              );
            } catch (e) {
              //alert(`문진표 리스트 에러 =${e}`);
            }
          }
        } else if (choiceNm === '병원문진') {
          vm.icon4 = 'ic-hosp-sel.png';
          vm.selectIconNm = '병원문진';
          let url = `/interviewtable/${this.receptNo}`;
          let result = null;
          if (this.$osType === 'web' || this.$osType === 'ios') {
            this.$axios
              .get(url)
              .then((response) => {
                this.optionHosp = response.data.data;
              })
              .catch((e) => {
                console.log(e);
              });
          } else {
            result = this.$util.getApi(`${this.$store.state.apiDomain}${url}`);
            this.optionHosp = result.data;
          }
        }
      } else {
        //guid있을경우
        if (this.returnChoiceNm === '' || this.returnChoiceNm === null) {
          $('.question-wrap .left ul li:nth-child(1)').addClass('active');
          this.icon1 = 'ic-checkup-sel.png';
          this.selectIconNm = '국가검진';
        } else {
          let choiceNm = '';
          if (this.returnChoiceNm === '' || this.returnChoiceNm === null) {
            choiceNm = $('.question-wrap .left ul li:nth-child(1) span').text();
          } else {
            choiceNm = this.returnChoiceNm;
          }

          if (choiceNm === '국가검진') {
            vm.icon1 = 'ic-checkup-sel.png';
            vm.selectIconNm = '국가검진';
          } else if (choiceNm === '영유아검진') {
            vm.icon2 = 'ic-infant-sel.png';
            vm.selectIconNm = '영유아검진';
          } else if (choiceNm === '정신건강문진') {
            vm.icon3 = 'ic-phych-sel.png';
            vm.selectIconNm = '정신건강문진';
            if (this.selectedInfo.mindGuid != '') {
              //정신건강 문진 추가 문진표. (의사가 환자들한테 직접 작성하고 오라는 용도의 문진표)
              let url = `${this.$store.state.checkupIp}/api/psych/np2/${this.$store.state.hospNo}/req/TB/paperInfos/${this.selectedInfo.mindGuid}`;
              //    let url = `${this.$store.state.checkupIp}/api/psych/np2/10350033/req/TB/paperInfos/A6bJXDP`;
              axios
                .get(url)
                .then((response) => {
                  vm.optionMind = response.data.data;
                })
                .catch((e) => {
                  console.log(e);
                });
            }
          } else if (choiceNm === '병원문진') {
            vm.icon4 = 'ic-hosp-sel.png';
            vm.selectIconNm = '병원문진';
          }
          $('.question-wrap .left ul li:contains(' + choiceNm + ')').addClass('active');
        }
      }
    } else {
      //국가검진이 설정에 없을 경우 첫번째 아이콘 활성화
      $('.question-wrap .left ul li:nth-child(1)').addClass('active');

      let choiceNm = '';
      if (this.returnChoiceNm === '' || this.returnChoiceNm === null) {
        choiceNm = $('.question-wrap .left ul li:nth-child(1) span').text();
      } else {
        choiceNm = this.returnChoiceNm;
      }
      if (choiceNm === '국가검진') {
        vm.icon1 = 'ic-checkup-sel.png';
        vm.selectIconNm = '국가검진';
      } else if (choiceNm === '영유아검진') {
        vm.icon2 = 'ic-infant-sel.png';
        vm.selectIconNm = '영유아검진';
      } else if (choiceNm === '정신건강문진') {
        vm.icon3 = 'ic-phych-sel.png';
        vm.selectIconNm = '정신건강문진';

        if (vm.selectedInfo.mindGuid != '') {
          //정신건강 문진 추가 문진표. (의사가 환자들한테 직접 작성하고 오라는 용도의 문진표)
          let url = `${this.$store.state.checkupIp}/api/psych/np2/${vm.$store.state.storeHospNo}/req/TB/paperInfos/${vm.selectedInfo.mindGuid}`;
          //	let url = `${this.$store.state.checkupIp}/api/psych/np2/{{요양기관}}/req/TB/paperInfos/{{guid}}`;
          try {
            axios
              .get(url)
              .then((response) => {
                vm.optionMind = response.data.data;
              })
              .catch((e) => {
                console.log(e);
              });
          } catch (e) {
            //alert(`문진표 리스트 에러 =${e}`);
          }
        }
      } else if (choiceNm === '병원문진') {
        vm.icon4 = 'ic-hosp-sel.png';
        vm.selectIconNm = '병원문진';
        let url = `/interviewtable/${this.receptNo}`;
        let result = null;
        if (this.$osType === 'web' || this.$osType === 'ios') {
          this.$axios
            .get(url)
            .then((response) => {
              this.optionHosp = response.data.data;
            })
            .catch((e) => {
              console.log(e);
            });
        } else {
          result = this.$util.getApi(`${this.$store.state.apiDomain}${url}`);
          this.optionHosp = result.data;
        }
      }
    }
  },
  methods: {
    pageBefore() {
      this.$router.push({
        name: '대기리스트'
      });
    },
    //병원 문진표
    async clickMoveHosp(intCd, intNm, writeYn) {
      //let url = `${this.$store.state.checkupIp}/ho/tb/${this.receptNo}/${intCd}/${writeYn}`;
      //문진 항목 가져오기.
      let url = `/interviewtable/viewer/${this.receptNo}/${intCd}`;
      let json = null;
      let result = null;
      if (this.$osType === 'web' || this.$osType === 'ios') {
        await this.$axios
          .get(url)
          .then((response) => {
            if (response.data.state !== 'success') {
              //alert('문진 항목 가져오기 실패');
              return;
            }
            json = response.data.data;
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        result = this.$util.getApi(`${this.$store.state.apiDomain}${url}`);
        json = result.data;
      }
      //url = `${this.$store.state.checkupIp}/HospPaper/ho/tb/${intNm}/${this.receptNo}/${intCd}/${writeYn}`;
      await this.$router
        .push({
          name: '문진표',
          params: {
            //url: encodeURI(url),
            checkType: 'ho',
            jsonData: json,
            intNm: intNm,
            intCd: intCd,
            writeYn: writeYn,
            receptNo: this.receptNo,
            ptntInfo: this.ptntInfo,
            returnChoiceNm: '병원문진',
            selectedInfo: this.selectedInfo,
            guid: this.guid
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    //국가검진
    clickMoveCheckUp() {
      this.$router
        .push({
          name: '문진표',
          params: {
            url: `${this.$store.state.checkupIp}/Checkup/start/IM/TB/${this.guid}`,
            receptNo: this.receptNo,
            checkType: 'IM',
            guid: this.$route.params.guid,
            ptntInfo: this.$route.params.ptntInfo,
            returnChoiceNm: '국가검진',
            selectedInfo: this.selectedInfo
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    //정신과 문진
    async clickMovePsych(str) {
      //정신과 문진
      //rp  접수 rs 예약
      let receptGb = '';
      if (this.activeTab === '00') {
        //예약
        receptGb = 'RS';
      } else {
        //접수 및 그외에.
        receptGb = 'RP';
      }
      var data = JSON.stringify({
        type: 'NP',
        reqGb: 'TB',
        pidx: '2',
        receptGb: receptGb,
        hospNo: this.$store.state.storeHospNo,
        hospNm: this.$store.state.storeHospNm,
        ptntNo: this.ptntInfo.ptntNo,
        ptntNm: this.ptntInfo.ptntNm,
        birthDay: this.ptntInfo.birthday,
        sex: this.ptntInfo.sex,
        appUid: null,
        receptNo: this.ptntInfo.receptNo,
        clinicYmd: this.ptntInfo.clinicYmd,
        visitPurpose: null,
        visitDetail: null,
        skipYn: 'N',
        reqJson: {
          hasGeneral: 'Y',
          hasLife: 'N',
          hasOld: 'N',
          hasDepression: 'N',
          hasCognitive: 'N',
          hasCancer: 'N',
          hasLady: 'N'
        }
      });
      var config = {
        method: 'post',
        url: `${this.$store.state.checkupIp}/api/checkup/new/np/TB/2/Y`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };

      let guid = '';
      await axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
          guid = response.data.data;
        })
        .catch(function (error) {
          console.log(error);
        });
      if (guid === '') {
        //alert('키생성실패');
      }

      this.$router
        .push({
          name: '문진표',
          params: {
            url: `${this.$store.state.checkupIp}/Psych/Index/${guid}/${str}`,
            receptNo: this.receptNo,
            selectedInfo: this.selectedInfo,
            guid: this.guid,
            ptntInfo: this.ptntInfo,
            activeTab: this.activeTab,
            returnChoiceNm: '정신건강문진'
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    //정신과 문진 추가된것.
    async clickMovePsychAdd(pidx) {
      this.$router
        .push({
          name: '문진표',
          params: {
            //url: `${this.$store.state.checkupIp}/Psych/Index/${guid}/${str}`,
            //url: `${this.$store.state.checkupIp}//Psych/paper/k3541D9/req/TB/hosp/10350033`,
            url: `${this.$store.state.checkupIp}/Psych/paper/${this.selectedInfo.mindGuid}/req/TB/hosp/${this.$store.state.storeHospNo}/info/${pidx}`,
            selectedInfo: this.selectedInfo,
            receptNo: this.receptNo,
            ptntInfo: this.ptntInfo,
            returnChoiceNm: '정신건강문진'
          }
        })
        .catch((e) => {
          console.log(e);
        });
      //	http://localhost:49999/Psych/paper/k3541D9/req/TB/hosp/10350033
    },
    clickBack() {
      const pwFlag = this.$store.state.settingInfo.questionPw || false;

      if (pwFlag) {
        this.propData = { parentPage: 'checkupLayout', closeFuncName: null, rightFuncName: 'pageBefore' };
        this.$refs.pinPasswordRef.open();
      } else {
        this.pageBefore();
      }
      clearInterval(this.$store.state.timerId2);
    },
    clickBackCheck() {
      popOpenAndScrollNone(`#checkupStateModal .dim-popup-mark`, `#checkupStateModal .dim-popup-content`);
    },
    checkupModalOK() {
      if (this.loginId === this.$store.state.storeUserId) {
        this.pageBefore();
      } else {
        this.modalGuide = true;
      }
    },
    checkupModalCancel() {
      popCloseAndScrollAuto(`#checkupStateModal .dim-popup-mark`, `#checkupStateModal .dim-popup-content`);
      this.modalGuide = false;
      this.loginId = '';
    },
    // 모달창 관련 : 문자열로 함수 실행
    parentFunc(functionName, param) {
      this[functionName](param);
    }
  }
};
</script>

<style lang="scss" scoped>
.common-top .top-info-wrap {
  position: relative;

  .prev-wrap {
    position: absolute;
    top: 0.2em;
  }
}
.title {
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 2rem;
  font-weight: 700;
  line-height: 3rem;
  color: #000;
  margin: 0 auto;
}
.common-top {
  padding-bottom: 30px;
}
.space {
  height: 71px;
}
.question-wrap {
  display: flex;
  min-height: calc(100vh - 71px);
  background: #f4f4f4;

  .left {
    width: 28%;
    padding: 30px 30px;
    border-right: 1px solid #e9e9e9;

    ul {
      display: flex;
      flex-direction: column;
      width: 100%;

      li {
        width: 100%;
        margin-bottom: 20px;
        padding: 32px 20px 20px 20px;
        text-align: center;
        background-color: #fff;
        border: 2px solid #fff;
        border-radius: 4px;

        figure {
          width: 64%;
          margin: 0 auto 10px;

          img {
            width: 100%;
          }
        }

        span {
          font-size: 1.75rem;
          font-weight: 600;
          color: #8d8d8d;
        }
      }

      li.active {
        border-color: #ff655a;

        span {
          color: #ff655a;
        }
      }
    }
  }
  .right {
    width: 72%;
    padding: 30px 30px;
    background-color: #fff;

    .bundle {
      &:nth-child(1) {
        h1 {
          margin-top: 0;
        }
      }
      h1 {
        margin-top: 2em;
        font-size: 1.6rem;
      }
      p {
        margin: 0.75em 0;
        padding: 1em;
        text-align: center;
        font-size: 1.75rem;
        background-color: #efefef;
        border-radius: 10px;
      }
      button {
        position: relative;
        display: block;
        width: 100%;
        margin: 0.75em 0;
        padding: 20px 5em;
        text-align: center;
        font-size: 1.75rem;
        background-color: #efefef;
        border-radius: 10px;

        .write-y {
          position: absolute;
          top: 50%;
          left: 20px;
          transform: translateY(-50%);
          padding: 5px 12px;
          color: #ff655a;
          font-size: 1.5rem;
          font-weight: 600;
          border: 1px solid #ff655a;
          border-radius: 50px;
          background-color: #fff;
        }
      }
      button:disabled {
        color: #d2d2d2;
        background-color: #f5f5f5;
      }
    }
  }

  .ckeckup-view-none {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: calc(100vh - 200px);

    img {
      width: 80px;
    }

    span {
      margin-top: 20px;
      font-size: 1.7rem;
      font-weight: 600;
    }
  }
}
</style>

<style scoped>
.disable {
  background: #efefef !important;
  border-color: #efefef !important;
}

li {
  box-shadow: 0 1px 3px rgb(199 199 199 / 12%), 0 1px 2px rgb(142 142 142 / 24%);
}
/* 모달 팝업 */
.dim-popup-content {
  width: 360px;
  padding: 30px 30px 100px;
}
.dim-popup-content header {
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 2.6rem;
  font-weight: 700;
  margin-bottom: 28px;
  line-height: 3rem;
  color: #000;
}
.dim-popup-content .text input {
  width: 100%;
  height: 47px;
  margin: 20px 0;
  padding: 0 12px;
  font-size: 2rem;
  font-family: 'NotoRegular';
  border: 1px solid #aaa;
  border-radius: 3px;
}
.dim-popup-content .text p {
  font-family: 'NotoMedium';
  font-size: 2.2rem;
}
.dim-popup-content .text p.guide {
  text-align: left;
  font-family: 'NotoMedium';
  font-size: 1.6rem;
  color: #ff655a;
}
.dim-popup-content .button.ok {
  width: 50%;
  left: 50%;
  color: #fff;
  background-color: #ff655a;
  border-bottom-left-radius: 0;
}
.dim-popup-content .button.close {
  width: 50%;
  border-bottom-right-radius: 0;
}
</style>
